import axios from "axios";
import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Form, Modal } from 'react-bootstrap'; 
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loader from "../../../Loader";


const DeleteTestimonial = (props) => {

  const token = useSelector((state) => state.token);
  const [loader, setLoader] = useState(false);
  const deleteTestimonial = () => {
    setLoader(true);
    axios({
      method:"DELETE",
      url:`${process.env.REACT_APP_BASE_URL}/testimonial/${props.testimonialId}`,
      headers: {
        "Authorization":`Bearer ${token}` 
      }
    }).then(res => {
      setLoader(false);
      props.getData();
      props.onHide();
      toast(res.data.message, {
        theme:"light",
        position:"top-right",
        type:"success"
      });
    }).catch(err => {
      setLoader(false);
      if (err?.response?.data?.errors) {
        toast(err.response.data.errors[0]?.msg, {
          theme:"light",
          position:"top-right",
          type:"error"
        });
      } else {
        toast(err?.response?.data?.message || err?.message || "Failed to remove testimonial", {
          theme:"light",
          position:"top-right",
          type:"error"
        });
      }
    });
  }

  return (
    <>
      <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="red" closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Delete Testimonial
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <span>Are you sure you want to delete your testimonial?</span>
      </Modal.Body>
      <Modal.Footer>
        <Button className='button red' onClick={() => deleteTestimonial()}>Delete</Button> 
      </Modal.Footer>
    </Modal>
    <Loader show={loader}/>
    </>
  )
}

export default DeleteTestimonial